import axios from 'axios';
import status from 'http-status'

import { store } from '../_helpers/store';
import { history } from './history';
import { alertActions } from '../_actions/alert.actions';

const instance = axios.create();

instance.interceptors.response.use(function (response) {
  return response; // 2xx Request
}, function (error) {
  if (error.response && error.response.status === status.UNAUTHORIZED && error.config.url !== `${process.env.REACT_APP_API_URL}/api/token`) {
    localStorage.clear();

    history.push('/login');

    store.dispatch(alertActions.error("Your session has timed out. Please log in."));
  }
  else if (error.response && error.response.status === status.UPGRADE_REQUIRED) {
    window.location.replace(error.response.data.domain)
  }
  else {
    return Promise.reject(error);
  }
});

instance.interceptors.request.use(function (request) {
  request.headers['X-Axs-Version'] = process.env.REACT_APP_API_VERSION;
  request.headers['X-Axs-Platform'] = process.env.REACT_APP_PLATFORM;

  return request;
})

export default instance;